import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Users, Search, Check, X } from 'lucide-react';
import {
  fetchClientsByStatus,
  approveClient,
  rejectClient,
  deactivateClient,
  activateClient
} from '../../../services/admin/api';
import './client-list.css';
import PricingPage from "../../Payment/Pricing/PricingPage";
import { MdHistory } from "react-icons/md";
import { FaWallet } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
const ClientList = () => {
  const [clients, setClients] = useState([]);
  const [sortColumn, setSortColumn] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState('asc');
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [isAsc, setIsAsc] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [actionType, setActionType] = useState("");
  const [isProcessing, setIsProcessing] = useState(false); // Add this
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  //const [showPricing, setShowPricing] = useState(false);

  //const [selectedClient, setSelectedClient] = useState(null);

  const isPending = location.pathname.includes('pending');
  const isRejected = location.pathname.includes('rejected');
  const isApproved = !isPending && !isRejected;
  const client = location.state?.client;

  const status = isPending
    ? 'PENDING'
    : isRejected
      ? 'REJECTED'
      : 'APPROVED';
  const openActionModal = (client, action) => {
    setSelectedClient(client);
    setActionType(action);
    setShowConfirmModal(true);
  };


  useEffect(() => {
    const fetchClients = async () => {
      try {
        setLoading(true);



        const result = await fetchClientsByStatus(
          status,
          currentPage,
          itemsPerPage,
          sortColumn,
          isAsc,
          searchTerm
        );

        if (result?.content) {
          setClients(result.content);
          setTotalPages(result.totalPages);
          setTotalElements(result.totalElements);
          setPageSize(result.size);

        } else {
          setClients([]);
          setTotalPages(0);
        }
      } catch (error) {
        console.error('Error fetching clients:', error);
        setClients([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, [status, currentPage, itemsPerPage, sortColumn, isAsc, searchTerm]);

  const openPricing = (client) => {

    //setSelectedClient(client);
    navigate(`/admin/pricing/${client.id}`, {
      state: {
        client
      }
    });


  };

  const openTransactionHistory = (client) => {

    navigate(`/admin/transaction-history/${client.id}`, {
      state: {
        client
      }
    });

  };
  const openClientWallet = (client) => {
    navigate(`/admin/client-wallet/${client.id}`, {
      state: {
        client
      }
    });
  };

  const renderSortArrow = (field) => {
    const isActive = sortColumn === field;

    return (
      <span
        className={`sort-icons ${isActive ? "sort-active" : ""
          }`}
      >

        {/* showing the next action button  */}
        {!isActive
          ? "▲▼"
          : sortOrder === "asc"
            ? "▼" : "▲"
        }
      </span>
    );
  };

  // handle the sort with consistency icons and defualt sort asc . 
  const handleSort = (column) => {
    if (sortColumn === column) {
      // Same column -> toggle
      const newIsAsc = !isAsc;
      setIsAsc(newIsAsc);
      setSortOrder(newIsAsc ? "asc" : "desc");
    } else {
      // Different column -> default to ascending
      setSortColumn(column);
      setIsAsc(true);
      setSortOrder("asc");
    }

    setCurrentPage(0);
  };


  const paginatedClients = clients;


  // ---------------- ACTIONS ----------------

  const handleNavigateToCandidates = (client) => {
    navigate(`/admin/client/${client.email}/candidates`, {
      state: {
        heading: 'Candidates List',
        clientUserId: client.id,
        clientName: client.username,
        companyName: client.companyName,
      },
    });
  };

  const handleApprove = async (id) => {
    await approveClient(id);
    // optional: refetch instead of filter
    setClients(prev => prev.filter(c => c.id !== id));
  };

  const handleReject = async (id) => {
    await rejectClient(id);
    setClients(prev => prev.filter(c => c.id !== id));
  };

  const handleDeactivate = async (clientId) => {
    try {
      const response = await deactivateClient(clientId);
      setClients(prev => {
        const updated = prev.map(client =>
          client.id === clientId
            ? { ...client, clientStatus: "INACTIVE" }
            : client
        );

        console.log(updated);
        return updated;
      });

      setShowConfirmModal(false);

      setSuccessMessage(response.message || "Client deactivated successfully");
      setShowSuccessPopup(true);

      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 2000);

    } catch (error) {
      setShowConfirmModal(false);

      setSuccessMessage(
        error.response?.data?.message || "Client is already deactivated"
      );

      setShowSuccessPopup(true);

      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 2500);
    }
  };
  const handleActivate = async (clientId) => {
    try {
      const response = await activateClient(clientId);
      setClients(prev => {
        const updated = prev.map(client =>
          client.id === clientId
            ? { ...client, clientStatus: "ACTIVE" }
            : client
        );

        console.log(updated); // Check updated client list
        return updated;
      });

      setShowConfirmModal(false);

      setSuccessMessage(response.message || "Client activated successfully");
      setShowSuccessPopup(true);

      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 2000);

    } catch (error) {
      setShowConfirmModal(false);

      setSuccessMessage(
        error.response?.data?.message || "Client is already active"
      );

      setShowSuccessPopup(true);

      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 2500);
    }
  };

  // ---------------- UI ----------------

  return (
    <div className="client-wrapper">
      <div className="clinet-table-controls">
        <div className="entries-select">
          Show{" "}
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(0);
            }}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>{" "}
          entries
        </div>

        <div className="client-search-box">
          <div className="client-search-input-wrapper">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(0);
              }}
            />
            <Search className="client-search-icon" size={18} />
          </div>
        </div>
      </div>

      <div className="clinet-table-container">
        <table className="candidates-clinet-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('username')}>
                Client Name {renderSortArrow('username')}
              </th>

              <th onClick={() => handleSort('companyname')}>
                Company {renderSortArrow('companyname')}
              </th>

              <th onClick={() => handleSort('email')}>
                Email {renderSortArrow('email')}
              </th>

              <th onClick={() => handleSort('phonenumber')}>
                Contact Number {renderSortArrow('phonenumber')}
              </th>
              <th>Status</th>
              {!isRejected && <th>Actions</th>}
            </tr>
          </thead>

          <tbody>
            {!loading && paginatedClients.length > 0 ? (
              paginatedClients.map((client) => (
                <tr key={client.id}>
                  <td>
                    {client.username}
                  </td>
                  <td>{client.companyName}</td>
                  <td>{client.email}</td>
                  <td>{client.phoneNumber}</td>

                  <td>
                    <div className="status-toggle-container">

                      <span
                        className={`status-badge ${client.clientStatus === "ACTIVE"
                            ? "status-active"
                            : "status-inactive"
                          }`}
                      >
                        {client.clientStatus}
                      </span>

                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={client.clientStatus === "ACTIVE"}
                          disabled={
                            client.clientStatus === "ACTIVE" && client.hasActiveBgv
                          }
                          onChange={() =>
                            openActionModal(
                              client,
                              client.clientStatus === "ACTIVE"
                                ? "deactivate"
                                : "activate"
                            )
                          }
                        />

                        <span className="slider round"></span>
                      </label>

                    </div>
                  </td>
                  {!isRejected && (
                    <td className='client-list-action'>
                      {isPending && (
                        <>
                          <button
                            className="candidate-btn"
                            title="Approve"
                            onClick={() => handleApprove(client.id)}
                          >
                            <Check size={16} />
                          </button>

                          <button
                            className="candidate-btn"
                            title="Reject"
                            onClick={() => handleReject(client.id)}
                          >
                            <X size={16} />
                          </button>
                        </>
                      )}
                      {isApproved && (
                        <>
                          <button
                            className="candidate-btn"
                            title="View Candidates"
                            onClick={() => handleNavigateToCandidates(client)}
                          >
                            <Users size={18} />
                          </button>
                          <button
                            className="pricing-view-btn"
                            onClick={() => openPricing(client)}
                            title="View Pricing"
                          >
                            <FaEye />
                          </button>
                        </>
                      )}
                      <button
                        className="pricing-view-btn"
                        onClick={() => openTransactionHistory(client)}
                        title="Transaction History"
                      >
                        <MdHistory />
                      </button>

                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="no-data">
                  No matching clients found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ Pagination (Backend Controlled) */}
      <div className="pagination">
        <div className="pagination-summary">
          {totalElements === 0 ? (
            <>Showing 0 to 0 of 0 entries</>
          ) : (
            <>
              Showing {currentPage * pageSize + 1} to{" "}
              {currentPage * pageSize + clients.length} of{" "}
              {totalElements} entries
            </>
          )}
        </div>

        <div className="pagination-buttons-user">
          <button
            className="page-btn"
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 0))}
            disabled={currentPage === 0}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={`page-btn ${currentPage === index ? "active" : ""}`}
              onClick={() => setCurrentPage(index)}
            >
              {index + 1}
            </button>
          ))}
          {/*  */}
          <button
            className="page-btn"
            onClick={() =>
              setCurrentPage(prev => Math.min(prev + 1, totalPages - 1))
            }
            disabled={currentPage >= totalPages - 1 || totalPages === 0}
          >
            Next
          </button>
        </div>
      </div>
      {/* Confirmation Popup */}
      {showConfirmModal && (
        <div className="confirm-overlay">
          <div className="confirm-modal">

            <h3 className="confirm-title">
              {actionType === "deactivate"
                ? "Deactivate Client"
                : "Activate Client"}
            </h3>

            <p>
              Are you sure you want to {actionType} this client?
            </p>

            <div className="confirm-actions">
              <button
                className="confirm-btn yes"
                disabled={isProcessing} // Disable while processing
                onClick={async () => {
                  setIsProcessing(true); // Start loading
                  if (actionType === "deactivate") {
                    await handleDeactivate(selectedClient.id);
                  } else {
                    await handleActivate(selectedClient.id);
                  }
                  setIsProcessing(false); // Stop loading
                }}
              >
                {isProcessing ? "Processing..." : "Yes"}
              </button>

              <button
                className="confirm-btn no"
                disabled={isProcessing} // Disable to prevent closing while processing
                onClick={() => setShowConfirmModal(false)}
              >
                No
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="success-popup">
          {successMessage}
        </div>
      )}

    </div>
  );

};

export default ClientList;